// Google Analytics event tracking utility
// Make sure Google Analytics script is loaded in index.html

export const trackEvent = (eventName, eventData = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, eventData);
  } else {
    console.warn('Google Analytics not loaded');
  }
};

// Booking & Inquiry Events
export const trackBookingInquiry = (formData, packageType) => {
  trackEvent('booking_inquiry', {
    event_type: formData.event_type,
    package_type: packageType,
    phone: formData.phone,
    email: formData.email,
    value: formData.totalPrice || 0
  });
};

export const trackBookingSubmitted = (bookingId, totalPrice, packageType, eventType) => {
  trackEvent('booking_submitted', {
    booking_id: bookingId,
    value: totalPrice,
    currency: 'INR',
    package_type: packageType,
    event_type: eventType
  });
};

export const trackAddonsSelected = (addonIds, addonPrice) => {
  trackEvent('add_ons_selected', {
    addon_count: addonIds.length,
    addon_value: addonPrice,
    currency: 'INR'
  });
};

// Payment Events
export const trackPaymentInitiated = (bookingId, amount) => {
  trackEvent('payment_initiated', {
    booking_id: bookingId,
    value: amount,
    currency: 'INR'
  });
};

export const trackPaymentCompleted = (bookingId, amount, paymentMethod = 'razorpay') => {
  trackEvent('purchase', {
    booking_id: bookingId,
    value: amount,
    currency: 'INR',
    payment_method: paymentMethod
  });
};

export const trackPaymentFailed = (bookingId, errorMessage) => {
  trackEvent('payment_failed', {
    booking_id: bookingId,
    error: errorMessage
  });
};

// Contact & Inquiry Events
export const trackWhatsAppClick = (source = 'unknown') => {
  trackEvent('whatsapp_contact', {
    source: source
  });
};

export const trackPhoneCall = (source = 'unknown') => {
  trackEvent('phone_contact', {
    source: source
  });
};

// Package View Events
export const trackPackageViewed = (packageType, price) => {
  trackEvent('view_item', {
    items: [{
      item_id: packageType,
      item_name: packageType,
      price: price,
      currency: 'INR'
    }]
  });
};

// Form Events
export const trackFormStarted = (formType) => {
  trackEvent('form_started', {
    form_type: formType
  });
};

export const trackFormCompleted = (formType, formData) => {
  trackEvent('form_completed', {
    form_type: formType,
    email: formData.email
  });
};

// Contract Events
export const trackContractSigned = (userId) => {
  trackEvent('contract_signed', {
    user_id: userId
  });
};

// Onboarding Events
export const trackOnboardingCompleted = (bookingId) => {
  trackEvent('onboarding_completed', {
    booking_id: bookingId
  });
};

// Page View Event (optional, GA tracks this automatically)
export const trackPageView = (pageTitle) => {
  trackEvent('page_view', {
    page_title: pageTitle
  });
};

// Scroll Event
export const trackSectionViewed = (sectionName) => {
  trackEvent('section_viewed', {
    section: sectionName
  });
};

// Video/Reel View
export const trackReelViewed = (reelId) => {
  trackEvent('reel_viewed', {
    reel_id: reelId
  });
};
